// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1TUxD","footer":"ModalFilter_footer__3UOlw"};